import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37cc8aa5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = { class: "block-wrap van-hairline--bottom" }
const _hoisted_3 = { class: "label-title" }
const _hoisted_4 = { class: "base-infos" }
const _hoisted_5 = { class: "block-wrap device-info-wrap van-hairline--bottom" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label-title" }, "投保设备", -1))
const _hoisted_7 = { class: "price-info block-wrap van-hairline--bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label-title" }, "预计退款金额", -1))
const _hoisted_9 = { class: "price-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_11 = { class: "number" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label-title" }, "填写信息", -1))
const _hoisted_13 = { class: "form-list" }
const _hoisted_14 = {
  key: 0,
  class: "upload-application-li van-hairline--bottom"
}
const _hoisted_15 = {
  key: 1,
  class: "verify-code-li"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-label",
  "data-required": ""
}, "验证码", -1))
const _hoisted_17 = { class: "verify-code-tips" }
const _hoisted_18 = { class: "van-hairline--bottom" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-label",
  "data-required": ""
}, "户名", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "username-tips" }, " * 申请退保的银行账号户名需与投保人一致，退款仅支持退回投保人本人银行账户，个人投保人退回个人账户，企业投保人退回公账。 ", -1))
const _hoisted_21 = { class: "van-hairline--bottom" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-label",
  "data-required": ""
}, "银行账号", -1))
const _hoisted_23 = { class: "van-hairline--bottom" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-label",
  "data-required": ""
}, "开户行", -1))
const _hoisted_25 = { class: "footer" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createTextVNode(" 注：退保申请服务由平安保险提供，预计退款金额不代表最终退 "),
  /*#__PURE__*/_createElementVNode("div", null, "款金额，实际退款金额以平安公司实际退款为准！")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "refund-tips" }, "退款预计将于1-3个工作日内退还，如有问题请咨400-95511。", -1))
const _hoisted_28 = { class: "confirm-agreement" }

import { useRouter } from 'vue-router'
import { onActivated, reactive, ref, Ref } from 'vue'
import { getThousandMoney } from '@/utils/index'
import { commonErrorHandle } from '@/utils/error-handle'
import { useInsuranceStore } from '@/compositions/insurance/index'
import { InsuranceJijiaOrderRefundDataStorage } from '@/storage/insurance'
import { Button, Form, Field, FieldRule, FormInstance, Checkbox } from 'vant'
import { getJijiaOrderRefundPrice, requestJijiaInsuranceRefund } from '@/apis/insurance'
import { RequestJijiaInsuranceRefundParams, ClientJijiaInsuranceListItem } from '@/types/insurance'
import {
  showToastLoading,
  clearToast,
  showConfirmModal,
  showToastSuccess,
  showToastFail,
} from '@/utils/tools'
import AppHeader from '@/components/Header.vue'
import DeviceCardInfo from '../components/device-card-info.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import JijiaVerifyCodeWrap from '../components/jijia-verify-code-wrap.vue'
import JijiaUploadApplcation from '../components/jijia-upload-application.vue'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'insurance-service-jijia-order-refund',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const orderData = InsuranceJijiaOrderRefundDataStorage.get<ClientJijiaInsuranceListItem>()
const phoneEndingNumber = orderData?.phone_number?.slice(-4) || ''
const formVm: Ref<FormInstance | null> = ref(null)
const proversionValue = orderData?.product_info?.pro_version
const isProNewVersion = Number(proversionValue) > 2023
const deviceInfo = ref({
  headInfo: {
    name: orderData.eq_name,
    img: orderData.eq_logo,
    sn: orderData.eq_sn,
    model: orderData.eq_model_name,
    activeTime: orderData.activate_at,
  },
  sn: orderData.eq_sn,
})
const $router = useRouter()
const refundPrice = ref('')
const agree = ref(false)
const isPersonal = String(orderData.personnel_type) === '1'
const formInfo: RequestJijiaInsuranceRefundParams['surrender_info'] = reactive({
  account_name: '',
  account: '',
  bank: '',
  code: '',
  apply_file: '',
})
const messagesMap = {
  account_name: '请填写户名',
  account: '请填写银行账号',
  bank: '请填写开户行',
  code: '请填写验证码',
  apply_file: '请上传申请书图片',
}
const {
  removeInsuranceListKeepAlive,
  addInsuranceRefundKeepAlive,
  removeInsuranceRefundKeepAlive,
} = useInsuranceStore()
function getFieldRuleConfig(key: keyof typeof messagesMap): FieldRule[] {
  const message = messagesMap[key]
  const result: FieldRule[] = [
    {
      required: true,
      trigger: 'onBlur',
      message,
    },
  ]
  return result
}
function customValidate() {
  // 自行校验Form没有默认支持的部分
  let bool = true
  if (!isPersonal && !formInfo.apply_file) {
    bool = false
  }
  return bool
}
async function validateHandle(): Promise<boolean> {
  // 验证参数
  let validateValue = true
  try {
    validateValue = customValidate()
    await formVm.value?.validate() // Form表单验证不通过会
  } catch (error) {
    console.log('error', error)
    validateValue = false
  }
  if (!validateValue) {
    showToastFail('请完善表单信息后再提交')
  }
  return validateValue
}
async function confirmRefund() {
  const validateValue = await validateHandle()
  if (!validateValue) {
    return
  }
  if (orderData.operation.operation_status === 0) {
    // 不可操作的情况
    showConfirmModal({
      title: '申请退保失败',
      message: orderData.operation.message,
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
    return
  }
  try {
    await showConfirmModal({
      message: '退保后将立即失效，无法再使用保险服务，确定退保?',
      className: 'repair-dialog',
      confirmButtonText: '确定退保',
    })
  } catch (error) {
    return
  }
  showToastLoading()
  try {
    await requestJijiaInsuranceRefund({
      policy_no: orderData.policy_no,
      surrender_info: formInfo,
    })
    clearToast()
    showToastSuccess('退保成功')
    removeInsuranceListKeepAlive()
    const query: Record<string, string | number> = {
      id: orderData.id,
      eq_sn: orderData.eq_sn,
    }
    if (orderData.policy_no) {
      query.policy_no = orderData.policy_no
    }
    setTimeout(() => {
      $router.replace({
        name: 'insurance-jijia-insurance-detail',
        query,
      })
    }, 2000)
  } catch (error) {
    const errorObj = error as { message: string }
    clearToast()
    showConfirmModal({
      title: '申请退保失败',
      message: errorObj?.message || '',
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
  }
}
function checkRule(e: Event) {
  e.stopPropagation()
  addInsuranceRefundKeepAlive()
  $router.push({
    name: 'insurance-jijia-inusrance-refund-word',
    query: {
      type: isProNewVersion ? '2024' : '2023',
    },
  })
}
async function initPageData() {
  showToastLoading()
  try {
    const data = await getJijiaOrderRefundPrice(orderData.policy_no)
    refundPrice.value = getThousandMoney(Math.abs(parseFloat(data.actual_premium_change)))
    clearToast()
  } catch (error) {
    commonErrorHandle(error)
  }
}

onActivated(() => {
  removeInsuranceRefundKeepAlive()
})
initPageData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "申请退保" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, "意外机损保险-" + _toDisplayString(_unref(orderData).product_info.pro_type_text), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, "保单号：" + _toDisplayString(_unref(orderData).policy_no), 1),
          _createElementVNode("div", null, "投保时间：" + _toDisplayString(_unref(orderData).created_at), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(DeviceCardInfo, {
          data: deviceInfo.value,
          class: "device-card-info"
        }, null, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(refundPrice.value), 1)
        ])
      ]),
      _createVNode(_unref(Form), {
        class: "block-wrap form-wrap",
        ref_key: "formVm",
        ref: formVm
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _createElementVNode("ul", _hoisted_13, [
            (!isPersonal)
              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                  _createVNode(JijiaUploadApplcation, {
                    fileUrl: formInfo.apply_file,
                    "onUpdate:fileUrl": _cache[0] || (_cache[0] = ($event: any) => ((formInfo.apply_file) = $event)),
                    mode: "surrender"
                  }, null, 8, ["fileUrl"])
                ]))
              : _createCommentVNode("", true),
            isPersonal
              ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(JijiaVerifyCodeWrap, {
                    code: formInfo.code,
                    "onUpdate:code": _cache[1] || (_cache[1] = ($event: any) => ((formInfo.code) = $event)),
                    policyNo: _unref(orderData).policy_no
                  }, null, 8, ["code", "policyNo"]),
                  _createElementVNode("div", _hoisted_17, " * 验证码会发送到投保账号的关联手机号 (尾号" + _toDisplayString(_unref(phoneEndingNumber)) + ") ", 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_18, [
              _hoisted_19,
              _createVNode(_unref(Field), {
                modelValue: formInfo.account_name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInfo.account_name) = $event)),
                class: "xa-field nongfu-field-wrap",
                placeholder: messagesMap.account_name,
                rules: getFieldRuleConfig('account_name')
              }, null, 8, ["modelValue", "placeholder", "rules"])
            ]),
            _hoisted_20,
            _createElementVNode("li", _hoisted_21, [
              _hoisted_22,
              _createVNode(_unref(Field), {
                modelValue: formInfo.account,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formInfo.account) = $event)),
                class: "xa-field nongfu-field-wrap",
                placeholder: messagesMap.account,
                rules: getFieldRuleConfig('account')
              }, null, 8, ["modelValue", "placeholder", "rules"])
            ]),
            _createElementVNode("li", _hoisted_23, [
              _hoisted_24,
              _createVNode(_unref(Field), {
                modelValue: formInfo.bank,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formInfo.bank) = $event)),
                class: "xa-field nongfu-field-wrap",
                placeholder: messagesMap.bank,
                rules: getFieldRuleConfig('bank')
              }, null, 8, ["modelValue", "placeholder", "rules"])
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode(CommonFooterWrap, { class: "van-hairline--top" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_unref(Checkbox), {
              modelValue: agree.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((agree).value = $event)),
              shape: "square",
              "icon-size": 16,
              "checked-color": "#00C378"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", { class: "checkbox-content" }, [
                  _createTextVNode("我已阅读并同意"),
                  _createElementVNode("span", {
                    class: "refund-rule",
                    onClick: checkRule
                  }, "《退保规则》")
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_unref(Button), {
            class: "next-button xa-vant-button",
            round: "",
            onClick: confirmRefund,
            disabled: !refundPrice.value || !agree.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("申请退保")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})